import React from "react";
import { Navbar } from '../components/Navbar';
import { GamesCard } from "../components/GamesCard";
import { GAMES } from "../gameList";

export class GamesPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            userID: -1,
            requiresLogin: false
        };

    }

    render() {
        return (
            <>
                <Navbar />
                <div className="container">
                    <div className="album py-5">
                        <div className="games-card-grid">
                            {GAMES.map((game) => <GamesCard key={game.name} game={game} />)}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}